const indexItems = [
  { title: '顶流明星恋情追踪合集', count: '28篇', desc: '持续追踪娱乐圈顶流明星的最新恋情动态与绯闻爆料' },
  { title: '综艺节目翻车名场面', count: '35篇', desc: '汇集各大综艺节目录制中的意外翻车与尴尬瞬间' },
  { title: '网红人设崩塌全纪录', count: '42篇', desc: '知名网红带货翻车、私生活黑料大起底完整合集' },
  { title: '娱乐圈资本运作揭秘', count: '19篇', desc: '深度解析娱乐圈背后的资本操作与明星投资陷阱' },
  { title: '影视剧争议事件汇总', count: '24篇', desc: '热门影视剧改编争议、抄袭质疑及相关黑料整理' },
  { title: '明星社交媒体翻车集', count: '31篇', desc: '明星社交媒体不当言论、小号被扒等翻车事件合集' },
  { title: '年度重磅黑料事件', count: '15篇', desc: '年度最具影响力的黑料事件完整回顾与深度分析' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            按主题整理的精选黑料合集，方便用户一站式浏览相关内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between gap-3 mb-3">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <span className="flex-shrink-0 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-label font-semibold whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
              <div className="mt-4 flex items-center text-xs text-primary-500 font-label font-semibold cursor-pointer whitespace-nowrap">
                浏览合集 <i className="ri-arrow-right-line ml-1"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}